import gql from 'graphql-tag'

/**
 * *(AI-generated)*
 * Returns a GraphQL query for fetching all favorited waterbody entities.
 */
export const allFavoritedWaterbodies = () => {
  return gql`
    query Entity($after: String, $filter: FavoriteFilter) {
      favoriteConnection(after: $after, filter: $filter) {
        edges {
          node {
            entity {
              ... on Lake {
                name
                id
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  `
}
